// extracted by mini-css-extract-plugin
export default {"button":"Example_button__dWst8","pages":"Example_pages__xmEGf"};